import { ProviderName } from 'v2/constants';
import { SelectOption } from 'v2/types';
import { ProviderTransactionActionType, ProviderTransactionFilter } from 'v2/types/ProviderTransactionModel';

export const TRANSACTIONS_TTL_DAYS = 14;

export const DEFAULT_LIMIT = 50;
export const LIMIT_OPTIONS: SelectOption<number>[] = [25, 50, 100].map((limit) => ({
  id: String(limit),
  value: limit,
  label: limit,
}));

export const INITIAL_FILTER: ProviderTransactionFilter = {
  userId: '',
  tournamentId: '',
  providerName: '',
  gameId: '',
  actionType: '',
  dateFrom: '',
  dateTo: '',
};

export const FILTER_KEYS = Object.keys(INITIAL_FILTER) as (keyof ProviderTransactionFilter)[];

const ALL_OPTION: SelectOption = { id: 'all', value: '', label: 'All' };

export const PROVIDER_OPTIONS: SelectOption[] = [
  ALL_OPTION,
  ...Object.values(ProviderName).map((provider) => ({ id: provider, value: provider, label: provider })),
];

export const FILTER_ACTION_TYPES: string[] = [
  ProviderTransactionActionType.BET,
  ProviderTransactionActionType.WIN,
  ProviderTransactionActionType.ROLLBACK,
];

export const ACTION_TYPE_OPTIONS: SelectOption[] = [
  ALL_OPTION,
  ...FILTER_ACTION_TYPES.map((type) => ({ id: type, value: type, label: type })),
];

// JDB and Truelab send bet and win in one callback: a single `bet` record whose amount is the spin result.
export const SPIN_RESULT_PROVIDERS: string[] = [ProviderName.JDB, ProviderName.TRUELAB];

export const USER_SEARCH_MIN_LENGTH = 3;
export const USER_SEARCH_DEBOUNCE = 500;

export const SLOT_SEARCH_MIN_LENGTH = 2;
export const SLOT_SEARCH_DEBOUNCE = 300;

export const SLOW_QUERY_MESSAGE = 'Запрос выполнялся слишком долго, сузьте фильтры (период, игра, провайдер)';
